import type { ComponentChildren, CSSProperties } from 'preact'

import {
  actionBarLeftMobileStyle,
  actionBarLeftStyle,
  actionBarMobileStyle,
  actionBarStyle,
  verticalActionStackStyle,
} from '../styles'

export function ActionBar({
  isMobile,
  left,
  right,
  padding,
  gap,
  leftGap,
  borderTop,
  style,
}: {
  isMobile: boolean
  left: ComponentChildren
  right?: ComponentChildren
  padding?: string
  gap?: string
  leftGap?: string
  borderTop?: string
  style?: CSSProperties
}) {
  return (
    <div
      style={{
        ...actionBarStyle,
        padding,
        gap,
        ...(borderTop ? { borderTop } : {}),
        ...(isMobile ? actionBarMobileStyle : {}),
        ...style,
      }}
    >
      <div
        style={{
          ...actionBarLeftStyle,
          gap: leftGap,
          ...(isMobile ? actionBarLeftMobileStyle : {}),
        }}
      >
        {left}
      </div>
      {right}
    </div>
  )
}

export function VerticalActionStack({
  className,
  style,
  children,
}: {
  className?: string
  style?: CSSProperties
  children: ComponentChildren
}) {
  return (
    <div
      className={className}
      style={{ ...verticalActionStackStyle, ...style }}
    >
      {children}
    </div>
  )
}
